export var sentry = process.env.SENTRY_DSN;
export var commit = process.env.COMMIT_VERSION;
var endpoints = {
  tracking: '/tracking',
  channel: '/channel',
  action: '/action',
  feedback: '/feedback',
  policy: 'https://after.sale/politicas-de-privacidade-termos-de-uso/'
};
export default endpoints;